import { backendAPI, transactionAPI } from "../../api"
import { updateDependencyRecords } from "../../../view/shared/utilities/cache"
import { safeApiCall } from "../../api/offline"
import { triggerAction } from "../../constants"
import uuid from "uuid"

export const cashout = (memberId, isMidCycle) => async (_, getState) => {
  const id = getState().group?.blockchain_key
  if (!id) {
    throw new Error("Group missing blockchain_key")
  }
  try {
    const url = `/${id}/members/${memberId}/cashout?midCycle=${isMidCycle}`
    const { data } = await safeApiCall(
      {
        cacheEnabled: true,
        url: url,
      },
      async () => transactionAPI.get(url),
    )
    return Promise.resolve(data)
  } catch (error) {
    console.log("Error: ", error)
    return Promise.reject(error)
  }
}

export const membersWithLoans = (state) => ({
  type: "SET_MEMBERS_WITH_LOANS",
  membersWithLoans: state,
})

export const membersTocashout = (state) => ({
  type: "CASHOUT_VSLA_MEMBERS",
  membersTocashout: state,
})

export const deleteCashoutMembers = (state) => ({
  type: "DELETE_CASHOUT_VSLA_MEMBERS",
  id: state,
})

export const deleteCashoutvslaMembers = (id) => async (dispatch) => {
  dispatch(deleteCashoutMembers(id))
}

export const loadingCashoutData = (status) => ({
  type: "lOADING_CASHOUT_DATA",
  loadingCashoutData: status,
})

export const cashoutStarted = (state) => ({
  type: "CASHOUT_STARTED",
  state,
})

export const canCashout = () => async (dispatch, getState) => {
  const id = getState().group?.id
  if (!id) {
    throw new Error("Group missing ID")
  }
  const url = `/transactions/groups/${id}/can-cashout`
  try {
    const { data } = await safeApiCall(
      {
        cacheEnabled: true,
        url: url,
      },
      async () => backendAPI.get(url),
    )
    dispatch(loadingCashoutData(data))
    if (data.membersWithLoans) {
      const memberLookup = getState().loadedvslaMembers.reduce((acc, member) => {
        acc[member.blockchain_wallet_id] = member
        return acc
      }, {})

      const transformedMembersWithLoans = data.membersWithLoans.map((item) => {
        const member = memberLookup[item.bcWalletId]
        if (!member) {
          return item // If member details not found, return the original item
        }
        return {
          full_name: item.name,
          blockchain_wallet_id: item.bcWalletId,
          dueLoanBalance: item.dueLoanBalance,
          ...member, // Include other member details
        }
      })

      dispatch(membersWithLoans(transformedMembersWithLoans))
    }
    return Promise.resolve(data.membersWithLoans)
  } catch (error) {
    console.log("Error: ", error)
    return Promise.reject(error)
  }
}

export const groupCashout = (groupId) => async () => {
  try {
    await backendAPI.delete(`/meetings/archive/groups/${groupId}`)
    return Promise.resolve()
  } catch (error) {
    console.log("Error: ", error)
    return Promise.reject(error)
  }
}

export const memberCashoutCheck = (memberId) => async () => {
  try {
    const { data } = await safeApiCall(
      {
        cacheEnabled: true,
        url: `/member-cashout/${memberId}`,
      },
      async () => transactionAPI.get(`/member-cachout/${memberId}`),
    )
    return Promise.resolve(data)
  } catch (error) {
    console.log("Error: ", error)
    return Promise.reject(error)
  }
}

const cashedOut = (params) => {
  if (!Array.isArray(params) || params.length === 0) {
    return false
  }
  return params.every((element) => element.amount === 0)
}

export const getCashoutDetails =
  (member, isMidCycle) => async (dispatch, getState) => {
    const id = getState().group?.id
    if (!id || !member?.id) {
      return
    }
    try {
      const cycle_id = getState().meeting?.ongoing.cycle_id
      const url = `/transactions/cashout`
      const { data } = await safeApiCall(
        {
          cacheEnabled: true,
          url: url,
        },
        async () =>
          backendAPI.post(url, {
            group_id: id,
            cycle_id,
            member_id: member.id,
            mid_cycle: isMidCycle ? true : false,
          }),
      )
      console.log("Cashout details data", data)
      dispatch(memberCashoutCheck(member.id))
      if (cashedOut(data)) dispatch(deleteCashoutvslaMembers(member.id))
      else {
        let obj = {
          name: member.name,
          member_id: member.id,
          balances: data,
        }
        return Promise.resolve(obj)
      }
    } catch (error) {
      console.log("Error: ", error)
      return Promise.reject(error)
    }
  }

export const confirmCashout =
  (memberId, meetingId, groupId, userId) => async (dispatch, getState) => {
    const { user, group, meeting, loadedMember, loadedvslaMembers, accountV2 } =
      getState()
    const cycle_id = getState().meeting?.ongoing.cycle_id
    const tempId = uuid.v4()

    const metaObject = {
      userId: user?.id,
    }

    // Handle dependencies
    const dependencies = {}
    if (!groupId) {
      dependencies["groupId"] = "group"
      await updateDependencyRecords(
        ["group", metaObject?.userId],
        {
          ...metaObject,
          value: null,
          key: "group_id",
          entityType: "group",
        },
        metaObject.userId,
      )
    }

    const needBodyUpdate = Object.keys(dependencies).length > 0 ? dependencies : null

    try {
      // --- Offline Balance Logic ---
      if (!accountV2.offline) {
        const initialState =
          Object.keys(accountV2.online.balances).length > 0
            ? accountV2.online
            : { balances: {} } // defaultGroupAccounts()

        dispatch({
          type: "INITIALIZE_OFFLINE_STATE",
          payload: initialState,
        })
      }

      // Use the pubkey from the currently loaded member as the consistent ID
      let member = loadedMember
      if (!member) {
        member = loadedvslaMembers.find((m) => m.id === memberId)
      }

      const offlineTxPayload = {
        member_id: member.pubkey,
        type: "cashout",
        cashout: true,
        groupId,
        meetingId,
      }

      dispatch({
        type: "UPDATE_OFFLINE_TRANSACTION",
        payload: offlineTxPayload,
      })
      // --- End Offline Balance Logic ---

      dispatch(
        triggerAction("ADD_TRANSACTION", {
          member_id: memberId,
          cashout: true,
          group_id: groupId,
          transaction_type: "cashout",
          request_id: tempId,
          meeting_id: meetingId,
          isOffline: true,
          transactionPartyName: member.full_name,
          status: "pending",
          requestId: tempId,
          createdAt: new Date().toISOString(),
          cycle_id,
        }),
      )

      const requestObject = {
        type: "WEBSOCKET_ACTION",
        pushEvent: "requests",
        receiveEvent: "response",
        emit: true,
        protocol: "ws",
        dependsOn: null,
        tempId: tempId,
        entityType: "cashout",
        userId: user?.id,
        optimisticActions: [],
        needBodyUpdate: needBodyUpdate,
        metadata: {
          userId: user?.id,
          callBackParams: [memberId, tempId],
          cacheKey: tempId,
          type: "transactions",
        },
        payload: {
          requestId: tempId,
          url: `${window.REACT_APP_PWA_APP_DOMAIN}/transactions/group-cashout`,
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
          userId: user?.id,
          method: "POST",
          data: {
            requestId: tempId,
            groupId: groupId,
            userId: userId,
            meetingId: meetingId,
            cycleId,
            createdAt: new Date().toISOString(),
          },
        },
      }

      return safeApiCall(requestObject)
    } catch (error) {
      const { response } = error
      if (!response || !response.data) {
        return
      }
      return Promise.reject()
    }
  }

export const confirmMidCycleCashout = (memberId) => async (dispatch, getState) => {
  const { user, group, meeting, loadedMember, loadedvslaMembers, accountV2 } =
    getState()
  const cycle_id = getState().meeting?.ongoing.cycle_id
  const tempId = uuid.v4()
  const meetingId = meeting?.ongoing?.id
  const groupId = group?.id
  const userId = user?.id

  const metaObject = {
    userId: user?.id,
  }

  // Handle dependencies
  const dependencies = {}
  if (!groupId) {
    dependencies["groupId"] = "group"
    await updateDependencyRecords(
      ["group", metaObject?.userId],
      {
        ...metaObject,
        value: null,
        key: "group_id",
        entityType: "group",
      },
      metaObject.userId,
    )
  }

  const needBodyUpdate = Object.keys(dependencies).length > 0 ? dependencies : null

  try {
    // --- Offline Balance Logic ---
    if (!accountV2.offline) {
      const initialState =
        Object.keys(accountV2.online.balances).length > 0
          ? accountV2.online
          : { balances: {} } // defaultGroupAccounts()

      dispatch({
        type: "INITIALIZE_OFFLINE_STATE",
        payload: initialState,
      })
    }

    // Use the pubkey from the currently loaded member as the consistent ID
    let member = loadedMember
    if (!member) {
      member = loadedvslaMembers.find((m) => m.id === memberId)
    }

    const offlineTxPayload = {
      member_id: member.pubkey,
      type: "midCycleCashout",
      cashout: true,
      groupId,
      meetingId,
    }

    dispatch({
      type: "UPDATE_OFFLINE_TRANSACTION",
      payload: offlineTxPayload,
    })
    // --- End Offline Balance Logic ---

    dispatch(
      triggerAction("ADD_TRANSACTION", {
        member_id: memberId,
        cashout: true,
        group_id: groupId,
        transaction_type: "midCycleCashout",
        request_id: tempId,
        meeting_id: meetingId,
        isOffline: true,
        transactionPartyName: member.full_name,
        status: "pending",
        requestId: tempId,
        createdAt: new Date().toISOString(),
        cycle_id,
      }),
    )

    const requestObject = {
      type: "WEBSOCKET_ACTION",
      pushEvent: "requests",
      receiveEvent: "response",
      emit: true,
      protocol: "ws",
      dependsOn: null,
      tempId: tempId,
      entityType: "midCycleCashout",
      userId: user?.id,
      optimisticActions: [],
      needBodyUpdate: needBodyUpdate,
      metadata: {
        userId: user?.id,
        callBackParams: [memberId, tempId],
        cacheKey: tempId,
        type: "transactions",
      },
      payload: {
        requestId: tempId,
        url: `${window.REACT_APP_PWA_APP_DOMAIN}/transactions/member-cashout?request_id=${tempId}`,
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
        userId: user?.id,
        method: "POST",
        data: {
          requestId: tempId,
          member_id: memberId,
          group_id: groupId,
          userId: userId,
          meeting_id: meetingId,
          cycle_id,
          createdAt: new Date().toISOString(),
        },
      },
    }

    return safeApiCall(requestObject)
  } catch (error) {
    const { response } = error
    if (!response || !response.data) {
      return
    }
    return Promise.reject()
  }
}
